import { render, staticRenderFns } from "./SideScrollNav.vue?vue&type=template&id=000ca724&scoped=true&"
import script from "./SideScrollNav.vue?vue&type=script&lang=js&"
export * from "./SideScrollNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ca724",
  null
  
)

export default component.exports